function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "helpful_notifications");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M645.97987,805.76163H252.99765s-7.96586-116.83255,39.16545-118.1602S333.98385,739.3795,393.064,666.35915s130.7728-69.03742,140.0663-25.889-17.92318,77.66709,31.86342,67.046S686.473,724.77543,645.97987,805.76163Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#ff3860"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M442.85508,805.78821l-1.32634-.05316c3.09318-76.92159,19.20317-126.34452,32.173-154.25937,14.08222-30.31051,27.6523-42.58083,27.78779-42.70141l.88229.99217c-.13354.11928-13.54546,12.26773-27.51488,42.37306C461.95875,679.93637,445.93693,729.15639,442.85508,805.78821Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#f2f2f2"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M585.08529,805.947l-1.27449-.3708c15.347-52.67656,51.487-85.935,51.85067-86.265l.892.98277C636.19305,720.62136,600.32336,753.64453,585.08529,805.947Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#f2f2f2"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M314.89412,805.853l-1.31532-.18281c5.20685-37.55258-4.19848-66.68812-13.00578-84.51665-9.53627-19.304-20.417-29.84732-20.52595-29.95169l.91859-.95814c.11053.10567,11.15952,10.81109,20.79757,30.32186C310.65286,738.56139,320.14732,767.966,314.89412,805.853Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#f2f2f2"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 763.78937,
  y: 26,
  width: 2,
  height: 185,
  fill: "#3f3d56"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M820.76154,769.84789c-5.68507,21.01543-25.15771,34.03082-25.15771,34.03082s-10.25533-21.05736-4.57026-42.07279,25.15771-34.03081,25.15771-34.03081S826.44661,748.83247,820.76154,769.84789Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#ff3860"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M769.04327,769.84789c5.68507,21.01543,25.15771,34.03082,25.15771,34.03082s10.25533-21.05736,4.57026-42.07279-25.15771-34.03081-25.15771-34.03081S763.3582,748.83247,769.04327,769.84789Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#ff3860"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M777.39708,765.33145c15.59991,15.18589,17.50533,38.53012,17.50533,38.53012s-23.387-1.27694-38.98695-16.46282-17.50533-38.53012-17.50533-38.53012S761.79717,750.14557,777.39708,765.33145Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#3f3d56"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M812.40773,765.33145c-15.59991,15.18589-17.50532,38.53012-17.50532,38.53012s23.387-1.27694,38.98694-16.46282,17.50533-38.53012,17.50533-38.53012S828.00764,750.14557,812.40773,765.33145Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#3f3d56"
});

var _ref12 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 417.5,
  cy: 718.7794,
  rx: 417.5,
  ry: 9.69734,
  fill: "#3f3d56"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M343.71535,551.82564l-5.54119,48.48542S318.78,647.41119,316.0094,682.04363L313.2388,720.832h18.00887s23.55007-55.41191,24.93536-70.65019L389.43018,549.055Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#a0616a"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M414.36554,551.82564l-5.54119,48.48542s-19.39417,47.10013-22.16476,81.73257L383.889,720.832h18.00887s23.55007-55.41191,24.93536-70.65019L460.08037,549.055Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#a0616a"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M429.60382,439.61651l15.23828,38.78834s-1.3853,33.24715,16.62357,30.47655-2.7706-36.01774-2.7706-36.01774L447.61269,432.69S433.75971,429.91943,429.60382,439.61651Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#a0616a"
});

var _ref16 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 294.8705,
  cy: 204.93536,
  r: 24.93536,
  fill: "#a0616a"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M385.27429,298.31613s-8.31179,27.706-13.853,27.706,37.403,16.62357,37.403,16.62357-11.08238-11.08238,0-31.86185Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#a0616a"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M358.95363,449.3136,322.93589,554.59623s12.46768,6.92649,33.24714,6.92649,113.59443-2.77059,114.97972-11.08238S442.0715,449.3136,442.0715,449.3136l-5.54119-34.63245L368.65071,432.69Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#2f2e41"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M335.40357,719.44668H310.4682l-4.15589,18.00887s-8.31179,5.54119-5.54119,18.00887,1.3853,38.78834,1.3853,38.78834l27.70595,18.00887s8.31179-9.69708,2.7706-26.32066Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#2f2e41"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M406.05376,719.44668H381.11839l-4.15589,18.00887s-8.31179,5.54119-5.54119,18.00887,1.3853,38.78834,1.3853,38.78834l27.706,18.00887s8.31179-9.69708,2.7706-26.32066Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#2f2e41"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M379.7331,323.25149s19.20925,5.09992,24.8429,10.86175l9.78954,5.76183,12.46768,26.32065s9.69709,4.1559,9.69709,22.16477,13.853,48.48542,13.853,48.48542,9.69708,8.31179,2.77059,12.46769-15.23827,4.15589-15.23827,4.15589,6.92649-26.32066-6.92649-27.706-20.77947-2.77059-22.16477,0-38.78834,42.94424-54.02661,38.78834-6.92649-45.71483-6.92649-45.71483l12.46768-96.97085s9.69708-1.38529,15.23827,0S379.7331,323.25149,379.7331,323.25149Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#d0cde1"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M332.633,439.61651l15.23828,38.78834S346.486,511.652,364.49482,508.8814s-2.77059-36.01774-2.77059-36.01774L350.64184,432.69S336.78886,429.91943,332.633,439.61651Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#a0616a"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M363.10952,323.25149l-2.77059-1.3853s-8.31179-8.31178-18.00887,2.7706-19.39417,69.26489-19.39417,69.26489v18.00887s-11.08239,15.23828-1.3853,23.55007S332.633,445.1577,332.633,445.1577s9.69709-13.853,20.77947-6.92649l1.3853-5.54119a17.1445,17.1445,0,0,0,2.77059-4.15589c1.3853-2.7706,4.1559,1.3853,2.7706-2.7706s0-5.54119,0-6.92649,1.3853-8.31178,1.3853-8.31178l-1.3853-42.94424Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#d0cde1"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M435.04493,284.78932s20.257-44.16535-32.6838-44.11791c0,0-32.48-17.06281-57.21392,22.50748L319.62312,304.784l6.52133-1.29623.82772,6.49192,8.321,5.10482,6.25855-6.468-1.03519,9.90146,71.69657,30.44847s-27.03054-29.933-16.60361-65.22428l4.23282,8.63925Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#2f2e41"
});

var _ref25 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 282.28937,
  cy: 212,
  rx: 3.5,
  ry: 7,
  fill: "#a0616a"
});

var _ref26 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "843.789 26 843.789 0 574.989 0 552.789 0 552.589 0 552.589 558 535.789 558 535.789 712 591.789 712 591.789 558 574.989 558 574.989 26 843.789 26",
  fill: "#3f3d56"
});

var _ref27 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 764.78937,
  cy: 26,
  rx: 79,
  ry: 14,
  fill: "#ff3860"
});

var _ref28 =
/*#__PURE__*/
React.createElement("rect", {
  x: 603.78937,
  y: 207,
  width: 322,
  height: 176,
  fill: "#ff3860"
});

var _ref29 =
/*#__PURE__*/
React.createElement("rect", {
  x: 631.78937,
  y: 250.83459,
  width: 222,
  height: 110.16541,
  fill: "#f2f2f2"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1007.89468,447.76163h-268v-134h268Zm-266-2h264v-130h-264Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#3f3d56"
});

var _ref31 =
/*#__PURE__*/
React.createElement("rect", {
  x: 670.82013,
  y: 283.91699,
  width: 143.93848,
  height: 2,
  fill: "#3f3d56"
});

var _ref32 =
/*#__PURE__*/
React.createElement("rect", {
  x: 670.82013,
  y: 304.91699,
  width: 143.93848,
  height: 2,
  fill: "#3f3d56"
});

var _ref33 =
/*#__PURE__*/
React.createElement("rect", {
  x: 670.82013,
  y: 325.91699,
  width: 143.93848,
  height: 2,
  fill: "#3f3d56"
});

var _ref34 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 920.78937,
  cy: 199,
  r: 46,
  fill: "#3f3d56"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1030.08609,298.61026l-23.02-23.02a4.00026,4.00026,0,1,1,5.65722-5.65722l16.98,16.98,54.18408-61.78858a3.99986,3.99986,0,0,1,6.01465,5.27442Z",
  transform: "translate(-109.10531 -85.76163)",
  fill: "#ff3860"
});

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "b4ceccf0-7969-46b0-a4b2-7f492d66dbb2",
    "data-name": "Layer 1",
    width: 981.78938,
    height: 728.47674,
    viewBox: "0 0 981.78938 728.47674",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.c3c2d01b.svg";
export { ForwardRef as ReactComponent };